var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:{
      'mt-4': _vm.index > 0,
      'mb-2 font-weight-bold text-dark h1': true,
    }},[_vm._v(" "+_vm._s(_vm.$t(("modules." + (_vm.$route.params.module) + ".entities." + (_vm.module.pages[_vm.$route.params.page].render.data) + ".fields." + _vm.id)))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }